import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  OverlayTrigger,
  Tooltip,
  Tab,
  Col,
  Nav,
  NavItem
} from 'react-bootstrap';
import { formatTimezoneDateTime, toggleScrollBody } from 'helper/unit-helper';
import * as WorkOrderActionType from '../constants';
import * as TradeActionType from 'Trades/constants';
import * as ItemActionType from 'Items/constants';
import * as SubcontractorActionType from 'Subcontractors/constants';
import * as ProjectActionType from 'Projects/constants';
import * as LotActionType from 'Lots/constants';
import * as WOTActionType from '../../Work-Order-Type/constants';
import * as PunchListActionType from '../../Punch-List/constants';
import ResolvePopup from '../Components/ResolvePopup';
import SignoffPopup from '../Components/SignoffPopup';
import DeclinePopup from '../Components/DeclinePopup';
import OpenPendingPopup from '../Components/OpenPendingPopup';
import ReopenPopup from '../Components/ReopenPopup';
import OpenAwaitPopup from '../Components/OpenAwaitPopup';
import CloseReopenPopup from '../Components/CloseReopenPopup';
import WorkOrderInfo from '../Components/WorkOrderInfo';
import EditWorkOrder from './edit-work-order';
import HomeownerEditWorkOrder from '../Components/HomeownerEditWorkOrder';
import WorkOrderHistory from '../Components/WorkOrderHistory';
// import ClosePendingPopup from '../Components/ClosePendingPopup';
import PendingOpenPopup from '../Components/PendingOpenPopup';
import { AppSettings } from '../../constants';
import Moment from 'moment';
import auth from 'Auth/authenticator';

class WorkOrderInformation extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    TradeList: PropTypes.any,
    ItemRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    itemRepairList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    UserList: PropTypes.any,
    LotList: PropTypes.any,
    WorkOrderTypeList: PropTypes.any,
    workOrderProfile: PropTypes.object,
    rfsId: PropTypes.string,
    workOrderId: PropTypes.string,
    rfsInformation: PropTypes.object,
    WorkOrderCredentials: PropTypes.any,
    RFSProfile: PropTypes.object,
    WorkOrderHistories: PropTypes.array,
    LotStore: PropTypes.object,
    UserProfile: PropTypes.object,
    addComment: PropTypes.func,
    isPunchItem: PropTypes.bool,
    checkHomeownerWO: PropTypes.string,
    UploadSuccess: PropTypes.bool,
    comments: PropTypes.any,
    LastResolvedByDetails: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.roleName = auth.getRoleName();
    this.state = {
      requireFormField: [],

      popup: {
        isShowOpenPopup: false,
        isShowPendPopup: false,
        isShowResolvePopup: false,
        isShowSignoffPopup: false,
        isShowDeclinePopup: false,
        isShowOpenPendingPopup: false,
        isShowReopenPopup: false,
        iShowCloseReopenPopup: false,
        iShowClosePendingPopup: false,
        isShowPendingOpenPopup: false
      },

      isReview: true,
      isEditResolved: false,
      isEditClosed: false,
      isEditReOpen: false,
      isEditAppointment: false
    };

    this.onTogglePopup = this.onTogglePopup.bind(this);
  }

  fetchTrade = () => {
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.rfsInformation.lot.id,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      }
    });
  };

  fetchItemRepair = tradeId => {
    this.props.dispatch({
      type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
      params: {
        id: tradeId,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      }
    });
  };

  fetchProblem = itemToRepairId => {
    this.props.dispatch({
      type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
      params: {
        id: itemToRepairId,
        searchKey: ''
      }
    });
  };

  fetchSubcontractor = tradeId => {
    this.props.dispatch({
      type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
      params: {
        projectId: this.props.rfsInformation.project.id,
        lotId: this.props.rfsInformation.lot.id,
        tradeId: tradeId,
        param: {
          searchKey: '',
          selectedValue: ''
        }
      },
      callback: () => {
        this.setState({ isFetchedSubcontractor: true });
      }
    });
  };

  fetchUser = () => {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_USER_ASYNC,
      params: {
        projectId: this.props.rfsInformation.project.id
      },
      callback: () => {
        this.setState({ isFetchedUser: true });
      }
    });
  };

  onFetchWorkOrderType = () => {
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      }
    });
  };

  onClickEditButtonSubcontractor = () => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    if (AppSettings.clientTypeValue === 'Subcontractor') {
      if (woInformation.status === 1) {
        this.setState({
          isEditAppointment: true
        });
      }
    }
  }
  onClickEditButton = () => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    if (woInformation.status === 4) {
      this.setState({
        isEditResolved: true
      });
    } else if (woInformation.status === 5) {
      this.setState({
        isEditClosed: true
      });
    // } else if (woInformation.status === 6) {
    //   this.setState({
    //     isEditReOpen: true
    //   });
    } else {
      this.setState({
        isReview: !this.state.isReview
      });
    }
  };

  onClickSubmitPopup = e => {
    e.preventDefault();
  };

  onClickSubmitOpenPend = (type, params) => {
    const { workOrderId, rfsId } = this.props;

    if (type === 'open') {
      this.props.dispatch({
        type: WorkOrderActionType.OPEN_AN_AWAITING_WORK_ORDER_ASYNC,
        params: {
          refNo: workOrderId,
          rfsId,
          data: params
        }
      });
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.PEND_WORK_ORDER_ASYNC,
        params: {
          refNo: workOrderId,
          rfsId,
          data: params
        }
      });
    }

    this.onClickCancelPopup();
  };

  onClickCancelPopup = () => {
    this.setState({ popup: {} });
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
    if (name === 'itemRepair') {
      this.setState({
        problem: null
      });
    }
    if (name === 'trade') {
      this.setState({
        subcontractor: null,
        itemRepair: null,
        problem: null
      });
    }
  };

  onTogglePopup = type => () => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    const requireFormField = [];
    if (!woInformation.trade) {
      requireFormField.push('trade');
    }
    if (!woInformation.subcontractorProfile && !woInformation.assignedUser) {
      requireFormField.push('assigned');
    }
    if (!woInformation.itemToRepair) {
      requireFormField.push('itemRepair');
    }
    if (!woInformation.problem) {
      requireFormField.push('problem');
    }
    if (!woInformation.workOrderType) {
      requireFormField.push('workOrderType');
    }

    if (!requireFormField.length && type === 'open') {
      let params = {
        tradeId: woInformation.trade.id,
        itemToRepairId: woInformation.itemToRepair.id,
        subcontractorId: woInformation.subcontractorProfile
          ? woInformation.subcontractorProfile.subcontractorId
          : null,
        assignedUserId: woInformation.assignedUser
          ? woInformation.assignedUser.id
          : null,
        workOrderTypeId: woInformation.workOrderType
          ? woInformation.workOrderType.id
          : null,
        problemId: woInformation.problem.id,
        status: 'Open'
      };
      this.onClickSubmitOpenPend(type, params);
    } else if (
      (requireFormField.length === 1 &&
        requireFormField.includes('assigned') &&
        type === 'pend') ||
      (requireFormField.length === 1 &&
        requireFormField.includes('workOrderType') &&
        type === 'pend') ||
      (requireFormField.length === 2 &&
        requireFormField.includes('assigned') &&
        requireFormField.includes('workOrderType') &&
        type === 'pend') ||
      (!requireFormField.length && type === 'pend')
    ) {
      let params = {
        tradeId: woInformation.trade.id,
        itemToRepairId: woInformation.itemToRepair.id,
        subcontractorId: woInformation.subcontractorProfile
          ? woInformation.subcontractorProfile.subcontractorId
          : null,
        assignedUserId: woInformation.assignedUser
          ? woInformation.assignedUser.id
          : null,
        workOrderTypeId: woInformation.workOrderType
          ? woInformation.workOrderType.id
          : null,
        problemId: woInformation.problem.id,
        status: 'Pending'
      };
      this.onClickSubmitOpenPend(type, params);
    } else {
      switch (type) {
        case 'open': {
          this.setState({
            popup: {
              isShowOpenPopup: !this.state.popup.isShowOpenPopup
            },
            requireFormField
          });
          break;
        }
        case 'pend':
          this.setState({
            popup: {
              isShowPendPopup: !this.state.popup.isShowPendPopup
            },
            requireFormField
          });
          break;
        default:
          break;
      }
    }
  };

  onToggleResolvePopup = () => {
    toggleScrollBody(this.state.popup.isShowResolvePopup);

    this.setState({
      popup: {
        isShowResolvePopup: !this.state.popup.isShowResolvePopup
      }
    },() => {
      this.onResetCheckUploadFile();
    });
  };

  onToggleSignoffPopup = () => {
    toggleScrollBody(this.state.popup.isShowSignoffPopup);
    this.props.dispatch({
      type: WorkOrderActionType.GET_LAST_RESOLVED_WORK_ORDER,
      params: {
      WOID: this.props.workOrderId,
      },
    });
    this.setState({
      popup: {
        isShowSignoffPopup: !this.state.popup.isShowSignoffPopup
      }
    },() => {
      this.onResetCheckUploadFile();
    });
  };

  onToggleDeclinePopup = () => {
    this.setState({
      popup: {
        isShowDeclinePopup: !this.state.popup.isShowDeclinePopup
      }
    });
  };

  onTogglePendingOpenPopup = () => {
    toggleScrollBody(this.state.popup.isShowPendingOpenPopup);

    this.setState({
      popup: {
        isShowPendingOpenPopup: !this.state.popup.isShowPendingOpenPopup
      }
    });
  };

  onSavePendingOpenPopup = holdReason => {
    const { workOrderId, rfsId, isPunchItem } = this.props;

    this.props.dispatch({
      type: WorkOrderActionType.PENDING_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: workOrderId,
        type: isPunchItem ? 'punchItem' : 'workOrder',
        rfsId,
        data: {
          holdReason
        }
      },
      callback: () => {
        this.onTogglePendingOpenPopup();
      }
    });
  };

  addWOComment(comment) {
    this.props.addComment(comment);
  }

  onSaveResolvePopup = (lastResolvedDate, comment, homeownerSignature) => {
    this.props.dispatch({
      type: WorkOrderActionType.RESOLVE_WORK_ORDER_ASYNC,
      params: {
        refNo: this.props.workOrderId,
        data: {
          status: 'Resolved',
          lastResolvedDate: lastResolvedDate,
          homeownerSignature: homeownerSignature,
          WorkOrderComments: comment
        },
        rfsRefNo: this.props.rfsId
      },
      callback: () => {
        if (comment) {
          const commentAction = 4;
          this.props.addComment(comment, commentAction);
        }
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE,
          params: {
              RefNo: this.props.rfsId,
              WorkOrderRefNo: this.props.workOrderId,
              Status: '4',
          }});
        this.onToggleResolvePopup();
        setTimeout(() => {
          this.props.dispatch({
            type: WorkOrderActionType.GET_LAST_RESOLVED_WORK_ORDER,
            params: {
              WOID: this.props.workOrderId,
            },
        })
        }, 5000);
      }
    });
  };

  onSaveResolveSubcontractorWOPopup = (lastResolvedDate, comment, homeownerSignature) => {
    const {
      workOrderProfile: { builderProfile }
    } = this.props;
    this.props.dispatch({
      type: WorkOrderActionType.RESOLVE_SUBCONTRACTOR_WORK_ORDER_ASYNC,
      params: {
        endpoint: builderProfile.resolveWOEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken,
        },
        data: {
          lastResolvedDate: lastResolvedDate,
          homeownerSignature: homeownerSignature,
          WorkOrderComments: comment
        }
      },
      callback: () => {
        if (comment) {
          const commentAction = 4;
          this.props.addComment(comment, commentAction);
        }
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE,
          params: {
              RefNo: this.props.rfsId,
              WorkOrderRefNo: this.props.workOrderId,
              Status: '4',
          }});
        this.onToggleResolvePopup();
      }
    });
  };

  onSavePendingSubcontractorOpenPopup = holdReason => {
    const {
      workOrderProfile: { builderProfile },
      rfsId
    } = this.props;
    this.props.dispatch({
      type: WorkOrderActionType.PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_ASYNC,
      params: {
        endpoint: builderProfile.holdWOEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        data: {
          holdReason
        }
      },
      callback: () => {
        this.onTogglePendingOpenPopup();
        if (AppSettings.clientTypeValue === 'Builder') {
          this.props.history.push('/work-order-list');
        } else {
          this.props.history.push(`/punch-lists/${rfsId}`);
        }
      }
    });
  };

  onSaveSignoffPopup = (lastResolvedDate, lastClosedDate, homeownerSignature) => {
    const resolveDate = this.props.workOrderProfile.workOrder.woInformation.lastResolvedDate;
    const lastResolveByName = this.props.LastResolvedByDetails !== undefined ? this.props.LastResolvedByDetails.actor
    :'';
    var signOffComment = ""
    this.props.comments && this.props.comments.items.map((createdDate) => {
      if(Moment(createdDate.createdDate).format('MM/DD/YYYY') == Moment(resolveDate).format('MM/DD/YYYY')){
        signOffComment = createdDate.comment
      }
    })
    
    //NOTE:
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileSignOff(lastResolvedDate, lastClosedDate, homeownerSignature, signOffComment,lastResolveByName);
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          item =>
            item.lot.id === this.props.workOrderProfile.requestDetail.lot.id
        );
        if (lotFound) {
          this.onSignOffHomeownerWorkOrder(
            lotFound.builderProfile,
            lastResolvedDate,
            lastClosedDate,
            homeownerSignature,
            signOffComment,
            lastResolveByName          
            );
        } else {
          this.onGetBuilderProfileSignOff(lastResolvedDate, lastClosedDate, homeownerSignature, signOffComment, lastResolveByName);
        }
      }
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.SIGN_OFF_WORK_ORDER_ASYNC,
        params: {
          refNo: this.props.workOrderId,
          rfsId: this.props.rfsId,
          data: {
            status: 'Closed',
            lastResolvedDate: lastResolvedDate,
            lastClosedDate: lastClosedDate,
            homeownerSignature: homeownerSignature,
            WorkOrderComments: signOffComment,
            WorkOrderResolvedBy:lastResolveByName
          }
        },
        callback: () => {
          this.props.dispatch({
            type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE,
            params: {
                RefNo: this.props.rfsId,
                WorkOrderRefNo: this.props.workOrderId,
                Status: '5',
            }});
        },
      });
    }
    this.onToggleSignoffPopup();
  };

  onGetBuilderProfileSignOff = (lastResolvedDate, lastClosedDate, homeownerSignature, signOffComment, lastResolveByName) => {
    let WOComments = signOffComment
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: this.props.workOrderProfile.requestDetail.lot.id
      },
      callbackGetBuilderProfile: builderProfile => {
        this.onSignOffHomeownerWorkOrder(
          builderProfile,
          lastResolvedDate,
          lastClosedDate,
          homeownerSignature,
          WOComments,
          lastResolveByName
        );
      }
    });
  };

  onSignOffHomeownerWorkOrder = (
    builderProfile,
    lastResolvedDate,
    lastClosedDate,
    homeownerSignature,
    signOffComment,
    lastResolveByName
  ) => {
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: WorkOrderActionType.SIGN_OFF_HOMEOWNER_WORK_ORDER_ASYNC,
      params: {
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        refNo: this.props.workOrderId,
        data: {
          status: 'Closed',
          // lastResolvedDate: lastResolvedDate,
          lastClosedDate: lastClosedDate,
          homeownerSignature: homeownerSignature,
          WorkOrderComments: signOffComment,
          WorkOrderResolvedBy:lastResolveByName
        }
      },
      callback:()=>{
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE,
          params: {
              RefNo: this.props.rfsId,
              WorkOrderRefNo: this.props.workOrderId,
              Status: '5',
          }});
      }
    });
  };

  onSendPunchItem = () => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    this.props.dispatch({
      type: PunchListActionType.SEND_PUNCH_ITEM_ASYNC,
      params: {
        punchListRefNo: this.props.rfsId,
        punchItemRefNo: this.props.workOrderId,
        data: {
          subcontractorId: woInformation.subcontractorProfile
            ? woInformation.subcontractorProfile.subcontractorId
            : null,
          assignedUserId: woInformation.assignedUser
            ? woInformation.assignedUser.id
            : null,
          status: 'Open'
        }
      }
    });
  };

  onSaveDeclinePopup = declineReason => {
    let projectID = this.props.workOrderProfile.requestDetail.project.id
    this.props.dispatch({
      type: WorkOrderActionType.DECLINE_WORK_ORDER_ASYNC,
      params: {
        refNo: this.props.workOrderId,
        rfsId: this.props.rfsId,
        data: {
          status: 'Declined',
          declinedReason: declineReason,
        },
        projectId: projectID
      },
      callback:()=>{
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA,
          params: {
              RefNo: this.props.rfsId,
              WorkOrderRefNo: this.props.workOrderId,
              Status: '3',
          }});
      }
    });
    this.onToggleDeclinePopup();
  };

  onSaveOpenPendingPopup = param => {
    this.props.dispatch({
      type: WorkOrderActionType.OPEN_PENDING_WORK_ORDER_ASYNC,
      params: {
        refNo: this.props.workOrderId,
        rfsId: this.props.rfsId,
        data: {
          status: 'Open',
          subcontractorId: param.subcontractorId,
          assignedUserId: param.assignedUserId,
          workOrderTypeId: param.workOrderTypeId
        }
      }
    });
  };

  onToggleOpenPendingPopup = () => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    if (
      (woInformation.subcontractorProfile || woInformation.assignedUser) &&
      woInformation.workOrderType
    ) {
      const param = {
        subcontractorId: woInformation.subcontractorProfile
          ? woInformation.subcontractorProfile.subcontractorId
          : null,
        assignedUserId: woInformation.assignedUser
          ? woInformation.assignedUser.id
          : null,
        workOrderTypeId: woInformation.workOrderType.id
      };
      this.onSaveOpenPendingPopup(param);
    } else {
      this.setState({
        popup: {
          isShowOpenPendingPopup: !this.state.popup.isShowOpenPendingPopup
        }
      });
    }
  };

  onToggleReopenPopup = () => {
    toggleScrollBody(this.state.popup.isShowReopenPopup);

    this.setState({
      popup: {
        isShowReopenPopup: !this.state.popup.isShowReopenPopup
      }
    });
  };

  onSaveReopenPopup = (isFromResolved, reopenReason) => {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileReOpen(reopenReason);
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          item =>
            item.lot.id === this.props.workOrderProfile.requestDetail.lot.id
        );
        if (lotFound) {
          this.onReopenHomeownerWorkOrder(
            lotFound.builderProfile,
            reopenReason
          );
        } else {
          this.onGetBuilderProfileReOpen(reopenReason);
        }
      }
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.RE_OPEN_WORK_ORDER_ASYNC,
        params: {
          refNo: this.props.workOrderId,
          rfsId: this.props.rfsId,
          isFromResolved: isFromResolved,
          data: {
            status: 'Reopen',
            reopenReason: reopenReason
          }
        },
        callback:()=>{
          console.log('RESOLVE_CLOSE_DATE_UPDATE ')
          this.props.dispatch({
            type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA,
            params: {
                RefNo: this.props.rfsId,
                WorkOrderRefNo: this.props.workOrderId,
                Status: '6',
            }});
        }
      });
    }
    this.onToggleReopenPopup();
  };

  onGetBuilderProfileReOpen = reopenReason => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: this.props.workOrderProfile.requestDetail.lot.id
      },
      callbackGetBuilderProfile: builderProfile => {
        this.onReopenHomeownerWorkOrder(builderProfile, reopenReason);
      }
    });
  };

  onReopenHomeownerWorkOrder = (builderProfile, reopenReason) => {
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: WorkOrderActionType.RE_OPEN_HOMEOWNER_WORK_ORDER_ASYNC,
      params: {
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        refNo: this.props.workOrderId,
        isFromResolved: true,
        data: {
          status: 'Reopen',
          reopenReason: reopenReason
        }
      },
      callback:()=>{
        this.props.dispatch({
          type: WorkOrderActionType.RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA,
          params: {
              RefNo: this.props.rfsId,
              WorkOrderRefNo: this.props.workOrderId,
              Status: '6',
          }});
      }
    });
  };

  onToggleCloseReopenPopup = () => {
    toggleScrollBody(this.state.popup.isShowCloseReopenPopup);

    this.setState({
      popup: {
        isShowCloseReopenPopup: !this.state.popup.isShowCloseReopenPopup
      }
    });
  };

  onToggleClosePendingPopup = () => {
    toggleScrollBody(this.state.popup.isShowClosePendingPopup);

    this.setState({
      popup: {
        isShowClosePendingPopup: !this.state.popup.isShowClosePendingPopup
      }
    });
  };

  onReviewReopenWorkOrder = data => {
    this.props.dispatch({
      type: WorkOrderActionType.REVIEW_RE_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: this.props.workOrderId,
        rfsId: this.props.rfsId,
        data: data
      }
    });
  };

  onResendNotice = () => {
    this.props.dispatch({
      type: WorkOrderActionType.RESEND_NOTICE_ASYNC,
      params: {
        refNo: this.props.workOrderId
      }
    });
  };

  handleModeResolved = () => {
    this.setState({ isEditResolved: false });
  };

  handleModeClosed = () => {
    this.setState({ isEditClosed: false });
  };

  handleModeOpenSubcontractor = () => {
    this.setState({ isEditAppointment: false});
  }

  handleModeReOpen = () => {
    this.setState({ isEditReOpen: false });
  };

  handleSaveEditAppointment = appointmentDate => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    const {
      workOrderProfile: { builderProfile }
    } = this.props;
    const params = {
      title: woInformation.title,
      description: woInformation.description,
      requestId: this.props.rfsId,
      tradeId: woInformation.trade.id,
      roomId: woInformation.room.id,
      itemToRepairId: woInformation.itemToRepair.id,
      subcontractorId: woInformation.subcontractorProfile
        ? woInformation.subcontractorProfile.subcontractorId
        : null,
      assignedUserId: woInformation.assignedUser
        ? woInformation.assignedUser.id
        : null,
      workOrderTypeId: woInformation.workOrderType
        ? woInformation.workOrderType.id
        : null,
      problemId: woInformation.problem.id,
      declinedReason: woInformation.declinedReason
        ? woInformation.declinedReason
        : null,
      lastClosedDate: woInformation.lastClosedDate
        ? woInformation.lastClosedDate
        : null,
      lastResolvedDate: woInformation.lastResolvedDate ? woInformation.lastResolvedDate : null,
      appointmentDate: Moment.isMoment(appointmentDate) ? Moment(appointmentDate).format() : appointmentDate
    };

    this.props.dispatch({
      //handle dispatch for edit appointment in subcontractor here
      type: WorkOrderActionType.EDIT_SUBCONTRACTOR_WORK_ORDER_ASYNC,
      params: {
        data: params,
        refNo: this.props.workOrderId,
        endpoint: builderProfile.editWOEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        }
      },
      callback: () => {
        this.handleModeOpenSubcontractor();
      }
    });
  }

  handleSaveEditResolved = lastResolvedDate => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    const params = {
      title: woInformation.title,
      description: woInformation.description,
      requestId: this.props.rfsId,
      tradeId: woInformation.trade.id,
      roomId: woInformation.room.id,
      itemToRepairId: woInformation.itemToRepair.id,
      subcontractorId: woInformation.subcontractorProfile
        ? woInformation.subcontractorProfile.subcontractorId
        : null,
      assignedUserId: woInformation.assignedUser
        ? woInformation.assignedUser.id
        : null,
      workOrderTypeId: woInformation.workOrderType
        ? woInformation.workOrderType.id
        : null,
      problemId: woInformation.problem.id,
      appointmentDate: woInformation.appointmentDate
        ? woInformation.appointmentDate
        : null,
      declinedReason: woInformation.declinedReason
        ? woInformation.declinedReason
        : null,
      lastClosedDate: woInformation.lastClosedDate
        ? woInformation.lastClosedDate
        : null,
      lastResolvedDate: formatTimezoneDateTime(lastResolvedDate)
    };

    this.props.dispatch({
      type: WorkOrderActionType.UPDATE_WORK_ORDER_ASYNC,
      params: {
        data: params,
        refNo: this.props.workOrderId
      },
      callback: () => {
        this.handleModeResolved();
      }
    });
  };

  handleSaveEditClosed = lastClosedDate => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    const params = {
      title: woInformation.title,
      description: woInformation.description,
      requestId: this.props.rfsId,
      tradeId: woInformation.trade.id,
      roomId: woInformation.room.id,
      itemToRepairId: woInformation.itemToRepair.id,
      subcontractorId: woInformation.subcontractorProfile
        ? woInformation.subcontractorProfile.subcontractorId
        : null,
      assignedUserId: woInformation.assignedUser
        ? woInformation.assignedUser.id
        : null,
      workOrderTypeId: woInformation.workOrderType
        ? woInformation.workOrderType.id
        : null,
      problemId: woInformation.problem.id,
      appointmentDate: woInformation.appointmentDate
        ? woInformation.appointmentDate
        : null,
      declinedReason: woInformation.declinedReason
        ? woInformation.declinedReason
        : null,
      lastResolvedDate: woInformation.lastResolvedDate
        ? woInformation.lastResolvedDate
        : null,
      lastClosedDate: formatTimezoneDateTime(lastClosedDate)
    };

    this.props.dispatch({
      type: WorkOrderActionType.UPDATE_WORK_ORDER_ASYNC,
      params: {
        data: params,
        refNo: this.props.workOrderId
      },
      callback: () => {
        this.handleModeClosed();
      }
    });
  };

  handleSubmitForReview = () => {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileSubmitReview();
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          item =>
            item.lot.id === this.props.workOrderProfile.requestDetail.lot.id
        );
        if (lotFound) {
          this.onSubmitReviewHomeownerWorkOrder(lotFound.builderProfile);
        } else {
          this.onGetBuilderProfileSubmitReview();
        }
      }
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.SUBMIT_DECLINED_WORK_ORDER_ASYNC,
        params: {
          refNo: this.props.workOrderId,
          rfsId: this.props.rfsId,
          data: {
            status: 0
          }
        }
      });
    }
  };

  onGetBuilderProfileSubmitReview = () => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: this.props.workOrderProfile.requestDetail.lot.id
      },
      callbackGetBuilderProfile: builderProfile => {
        this.onSubmitReviewHomeownerWorkOrder(builderProfile);
      }
    });
  };

  onSubmitReviewHomeownerWorkOrder = builderProfile => {
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: WorkOrderActionType.SUBMIT_DECLINED_HOMEOWNER_WORK_ORDER_ASYNC,
      params: {
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        param: {
          refNo: this.props.workOrderId,
          data: {
            status: 0
          }
        }
      }
    });
  };

  onSignOffUploadFile = file => {
    this.props.dispatch({
      type: WorkOrderActionType.SIGN_OFF_UPLOAD_ATTACHMENT_TO_S3_ASYNC,
      params: {
        refNo: this.props.workOrderId,
        config: this.props.WorkOrderCredentials,
        file: file
      },
      callback: this.signOffUploadFileToServe(file.name)
    });
  };

  signOffUploadFile = file => {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfileSignOffUploadFile(file);
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          item =>
            item.lot.id === this.props.workOrderProfile.requestDetail.lot.id
        );
        if (lotFound) {
          this.onSignOffHomeownerUploadFile(lotFound.builderProfile, file);
        } else {
          this.onGetBuilderProfileSignOffUploadFile(file);
        }
      }
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
        params: { resourcePath: `work-order/${this.props.workOrderId}` },
        callback: () => {
          this.onSignOffUploadFile(file);
        }
      });
    }
  };

  onGetBuilderProfileSignOffUploadFile = file => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: this.props.workOrderProfile.requestDetail.lot.id
      },
      callbackGetBuilderProfile: builderProfile => {
        this.onSignOffHomeownerUploadFile(builderProfile, file);
      }
    });
  };

  onSignOffHomeownerUploadFile = (builderProfile, file) => {
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: WorkOrderActionType.HOMEOWNER_SETUP_AWS_S3_ASYNC,
      params: {
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        param: { resourcePath: `work-order/${this.props.workOrderId}` }
      },
      callback: () => {
        this.onSignOffUploadFile(file);
      }
    });
  };

  signOffUploadFileToServe = fileName => data => {
    this.props.dispatch({
      type: WorkOrderActionType.UPLOAD_TO_SERVER_ASYNC,
      params: {
        refNo: this.props.workOrderId,
        rfsId: this.props.rfsId,
        data: {
          url: data.Location,
          key: data.Key,
          fileName: fileName
        }
      }
    });
  };

  handleSaveEditReOpen = data => {
    data['status'] = 6; //re-open
    this.props.dispatch({
      type: WorkOrderActionType.EDIT_REQUESTED_RE_OPEN_WORK_ORDER_ASYNC,
      params: {
        refNo: this.props.workOrderId,
        data
      },
      callback: () => {
        this.handleModeReOpen();
      }
    });
  };

  toolTip(type) {
    return (
      <Tooltip className='in tooltip-siteone'>
        {type === 'open' && <span>Send this work order to the assignee</span>
        // <span>Opening a work order will also send it to the specified subcontractor.</span>
        }
        {type === 'pend' && (
          // <span>Pending a work order will not send it to the specified subcontractor (if any)</span>
          <span>
            Pending a work order will not send it to the assignee (if any)
          </span>
        )}
      </Tooltip>
    );
  }

  bindingWorkOrderHistory = () => {
    const { workOrderId, rfsId } = this.props;

    this.props.dispatch({
      type: WorkOrderActionType.GET_WORK_ORDER_HISTORY_ASYNC,
      params: {
        refNo: workOrderId,
        rfsId
      }
    });
  };

  onCheckHomeownerSignatureWO = () => {
    const { workOrderId, rfsId } = this.props;
    this.props.dispatch({
      type: WorkOrderActionType.CHECK_HOMEOWNER_SIGNATURE_WO_ASYNC,
      params: {
        refNo: workOrderId
      }
    });
  }

  onCheckUploadFile = () => {
    this.props.dispatch({
      type: WorkOrderActionType.UPLOAD_SIGNATURE_CHECK_STATUS
    });
  }
  onResetCheckUploadFile = () => {
    this.props.dispatch({
      type: WorkOrderActionType.UPLOAD_SIGNATURE_RESET_STATUS
    });
  }

  isWOCloseBtnEnabled = () => {
    return this.props.workOrderProfile.requestDetail !== undefined && this.props.workOrderProfile.requestDetail.restrictWOCloseOption;
    const clientId = AppSettings.CLIENT_ID;
    return (clientId ==='www.ph.siteoneservicesdemo.com' || clientId ==='www.perryhomes.siteoneservices.com') ? this.props.workOrderProfile.requestDetail !== undefined && this.props.workOrderProfile.requestDetail.restrictWOCloseOption : true;
  }

  isAdmin = () => {
    return this.roleName === AppSettings.SYSTEM_ADMINISTRATOR || this.roleName === AppSettings.BUILDER_ADMIN || this.roleName === AppSettings.BUILDER_SUPER_ADMIN;
  }
  renderButtonGroup() {
    if (AppSettings.clientTypeValue === 'Subcontractor') {
      if (this.props.workOrderProfile.workOrder.woInformation.status === 1 && !this.state.isEditAppointment && this.props.workOrderProfile.viewOnly === false) {
        return (
          <ul className='wo-detail-bottom-btn'>
            <li className='wo-edit-li'>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.onClickEditButtonSubcontractor}>
                  Edit
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                onClick={this.onToggleResolvePopup}
              >
                Resolve
              </button>
              {this.state.popup.isShowResolvePopup && (
                <ResolvePopup
                  onSaveResolvePopup={this.onSaveResolveSubcontractorWOPopup}
                  onCancelResolvePopup={this.onToggleResolvePopup}
                  WorkOrderProfile={this.props.workOrderProfile}
                  WorkOrderCredentials={this.props.WorkOrderCredentials}
                  rfsId={this.props.rfsId}
                  workOrderId={this.props.workOrderId}
                  onCheckHomeownerSignatureWO={this.onCheckHomeownerSignatureWO}
                  checkHomeownerWO={this.props.checkHomeownerWO}
                  onCheckUploadFile={this.onCheckUploadFile}
                  onResetCheckUploadFile={this.onResetCheckUploadFile}
                  UploadSuccess={this.props.UploadSuccess}
                />
              )}
            </li>
            <li>
              <button
                className='btn btn-primary btn-siteone btn-wo-decline'
                onClick={this.onTogglePendingOpenPopup}
              >
                Pending
              </button>
              {this.state.popup.isShowPendingOpenPopup && (
                <PendingOpenPopup
                  onSavePendingOpenPopup={
                    this.onSavePendingSubcontractorOpenPopup
                  }
                  onCancelPendingOpenPopup={this.onTogglePendingOpenPopup}
                />
              )}
            </li>
          </ul>
        );
      }
      return null;
    }

    return (
      <div>
        {/* Status: Schedule */}
        {this.props.workOrderProfile.workOrder.woInformation.status === 7 &&
          AppSettings.clientTypeValue === 'Builder' && (
            <ul className='wo-detail-bottom-btn'>
              <li>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-edit'
                  onClick={this.onClickEditButton}
                >
                  Edit
                </button>
              </li>
            </ul>
          )}
        {/* Status: Awaiting Review */}
        {this.props.workOrderProfile.workOrder.woInformation.status === 0 &&
          AppSettings.clientTypeValue !== 'Homeowner' && (
            <ul className='wo-detail-bottom-btn'>
              <li className='wo-edit-li'>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-edit'
                  onClick={this.onClickEditButton}
                >
                  Edit
                </button>
              </li>
              <li>
                {this.state.popup.isShowOpenPopup && (
                  <OpenAwaitPopup
                    isOpen={true}
                    woInformation={
                      this.props.workOrderProfile.workOrder.woInformation
                    }
                    rfsInformation={this.props.rfsInformation}
                    onFetchItemRepair={data => this.fetchItemRepair(data)}
                    onFetchProblem={data => this.fetchProblem(data)}
                    onFetchSubcontractor={data => this.fetchSubcontractor(data)}
                    onFetchTrade={this.fetchTrade}
                    onFetchUser={this.fetchUser}
                    onFetchWOT={this.onFetchWorkOrderType}
                    userList={this.props.UserList}
                    itemRepairList={this.props.ItemRepairList}
                    problemList={this.props.ProblemList}
                    subcontractorList={this.props.SubcontractorList}
                    tradeList={this.props.TradeList}
                    workOrderTypeList={this.props.WorkOrderTypeList}
                    requireFormField={this.state.requireFormField}
                    onCancelPopup={this.onTogglePopup('open')}
                    onSubmit={(type, params) =>
                      this.onClickSubmitOpenPend(type, params)
                    }
                  />
                )}
                <OverlayTrigger
                  placement='top'
                  overlay={this.toolTip('open')}
                  delayHide={10}
                  delayShow={500}
                >
                  <button
                    className='btn btn-primary btn-siteone'
                    onClick={this.onTogglePopup('open')}
                  >
                    Send
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                {this.state.popup.isShowPendPopup && (
                  <OpenAwaitPopup
                    isOpen={false}
                    woInformation={
                      this.props.workOrderProfile.workOrder.woInformation
                    }
                    rfsInformation={this.props.rfsInformation}
                    onFetchItemRepair={data => this.fetchItemRepair(data)}
                    onFetchProblem={data => this.fetchProblem(data)}
                    onFetchSubcontractor={data => this.fetchSubcontractor(data)}
                    onFetchTrade={this.fetchTrade}
                    onFetchUser={this.fetchUser}
                    userList={this.props.UserList}
                    itemRepairList={this.props.ItemRepairList}
                    problemList={this.props.ProblemList}
                    subcontractorList={this.props.SubcontractorList}
                    tradeList={this.props.TradeList}
                    requireFormField={this.state.requireFormField}
                    onCancelPopup={this.onTogglePopup('pend')}
                    onSubmit={(type, params) =>
                      this.onClickSubmitOpenPend(type, params)
                    }
                  />
                )}
                <OverlayTrigger
                  placement='top'
                  overlay={this.toolTip('pend')}
                  delayHide={10}
                  delayShow={500}
                >
                  <button
                    className='btn btn-primary btn-siteone'
                    onClick={this.onTogglePopup('pend')}
                  >
                    Pending
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <button
                  className='btn btn-primary btn-siteone btn-wo-decline'
                  onClick={this.onToggleDeclinePopup}
                >
                  No further attention
                </button>
                {this.state.popup.isShowDeclinePopup && (
                  <DeclinePopup
                    onCancelDeclinePopup={this.onToggleDeclinePopup}
                    onSaveDeclinePopup={this.onSaveDeclinePopup}
                  />
                )}
              </li>
            </ul>
          )}

        {this.props.workOrderProfile.workOrder.woInformation.status === 0 &&
          AppSettings.clientTypeValue === 'Homeowner' && (
            <ul className='wo-detail-bottom-btn'>
              <li>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-edit'
                  onClick={this.onClickEditButton}
                >
                  Edit
                </button>
              </li>
            </ul>
          )}

        {/* Status: Open */}
        {this.props.workOrderProfile.workOrder.woInformation.status === 1 && (
          <ul className='wo-detail-bottom-btn'>
            <li className='wo-edit-li'>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.onClickEditButton}
              >
                Edit

              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                onClick={this.onToggleResolvePopup}
              >
                Resolve
              </button>
              {this.state.popup.isShowResolvePopup && (
                <ResolvePopup
                  onSaveResolvePopup={this.onSaveResolvePopup}
                  onCancelResolvePopup={this.onToggleResolvePopup}
                  rfsId={this.props.rfsId}
                  workOrderId={this.props.workOrderId}
                  onCheckHomeownerSignatureWO={this.onCheckHomeownerSignatureWO}
                  checkHomeownerWO={this.props.checkHomeownerWO}
                  onCheckUploadFile={this.onCheckUploadFile}
                  onResetCheckUploadFile={this.onResetCheckUploadFile}
                  UploadSuccess={this.props.UploadSuccess}
                />

              )}
            </li>
            {(this.isAdmin() === true || this.isWOCloseBtnEnabled()) &&
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-close'
                onClick={this.onToggleSignoffPopup}
              >
                Close
              </button>
              {this.state.popup.isShowSignoffPopup && (
                <SignoffPopup
                  workOrderId={this.props.workOrderId}
                  isSignoffFromOpen={true}
                  onSaveSignoffPopup={this.onSaveSignoffPopup}
                  onCancelSignoffPopup={this.onToggleSignoffPopup}
                  rfsId={this.props.rfsId}
                  onCheckHomeownerSignatureWO={this.onCheckHomeownerSignatureWO}
                  checkHomeownerWO={this.props.checkHomeownerWO}
                  onCheckUploadFile={this.onCheckUploadFile}
                  onResetCheckUploadFile={this.onResetCheckUploadFile}
                  UploadSuccess={this.props.UploadSuccess}
                />
              )}
            </li>
            }
            <li>
              <button
                className='btn btn-primary btn-siteone btn-wo-decline'
                onClick={this.onTogglePendingOpenPopup}
              >
                Pending
              </button>
              {this.state.popup.isShowPendingOpenPopup && (
                <PendingOpenPopup
                  onSavePendingOpenPopup={this.onSavePendingOpenPopup}
                  onCancelPendingOpenPopup={this.onTogglePendingOpenPopup}
                />
              )}
            </li>
          </ul>
        )}

        {/* Status: Resolved (mode review) */}
        {this.props.workOrderProfile.workOrder.woInformation.status === 4 &&
          !this.state.isEditResolved && (
            <ul className='wo-detail-bottom-btn'>
              {AppSettings.clientTypeValue !== 'Homeowner' && (
                <li className='wo-edit-li'>
                  <button
                    className='btn btn-primary btn-siteone-default btn-wo-edit'
                    onClick={this.onClickEditButton}
                  >
                    Edit
                  </button>
                </li>
              )}
            {(this.isAdmin() === true || this.isWOCloseBtnEnabled()) &&
            AppSettings.clientTypeValue !== 'Homeowner'&&
              <li>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-close'
                  onClick={this.onToggleSignoffPopup}
                >
                  Close
                </button>
                {this.state.popup.isShowSignoffPopup && (
                  <SignoffPopup
                    isSignoffFromOpen={false}
                    onSaveSignoffPopup={this.onSaveSignoffPopup}
                    onCancelSignoffPopup={this.onToggleSignoffPopup}
                    onUploadFileToS3={this.signOffUploadFile}
                    rfsId={this.props.rfsId}
                    workOrderId={this.props.workOrderId}
                    onCheckHomeownerSignatureWO={this.onCheckHomeownerSignatureWO}
                    checkHomeownerWO={this.props.checkHomeownerWO}
                    onCheckUploadFile={this.onCheckUploadFile}
                    onResetCheckUploadFile={this.onResetCheckUploadFile}
                    UploadSuccess={this.props.UploadSuccess}
                  />
                )}
              </li>
              }
              {AppSettings.clientTypeValue === 'Homeowner'&&
                <li>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-close'
                  onClick={this.onToggleSignoffPopup}
                >
                  Sign off
                </button>
                {this.state.popup.isShowSignoffPopup && (
                  <SignoffPopup
                    isSignoffFromOpen={false}
                    onSaveSignoffPopup={this.onSaveSignoffPopup}
                    onCancelSignoffPopup={this.onToggleSignoffPopup}
                    onUploadFileToS3={this.signOffUploadFile}
                    rfsId={this.props.rfsId}
                    workOrderId={this.props.workOrderId}
                    onCheckHomeownerSignatureWO={this.onCheckHomeownerSignatureWO}
                    checkHomeownerWO={this.props.checkHomeownerWO}
                    onCheckUploadFile={this.onCheckUploadFile}
                    onResetCheckUploadFile={this.onResetCheckUploadFile}
                    UploadSuccess={this.props.UploadSuccess}
                  />
                )}
              </li>
              }
              <li>
                {this.state.popup.isShowReopenPopup && (
                  <ReopenPopup
                    onSaveReopenPopup={data =>
                      this.onSaveReopenPopup(true, data)
                    }
                    onCancelReopenPopup={this.onToggleReopenPopup}
                  />
                )}
                <button
                  className='btn btn-primary btn-siteone btn-wo-decline'
                  onClick={this.onToggleReopenPopup}
                >
                  Request to Re-open
                </button>
              </li>
            </ul>
          )}

        {/* Status: Closed */}
        {this.props.workOrderProfile.workOrder.woInformation.status === 5 &&
          !this.state.isEditClosed && (
            <ul className='wo-detail-bottom-btn'>
              <li className='wo-edit-li'>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-edit'
                  onClick={this.onClickEditButton}
                >
                  Edit
                </button>
              </li>
              <li>
                {this.state.popup.isShowReopenPopup && (
                  <ReopenPopup
                    onSaveReopenPopup={data =>
                      this.onSaveReopenPopup(false, data)
                    }
                    onCancelReopenPopup={this.onToggleReopenPopup}
                  />
                )}
                <button
                  className='btn btn-primary btn-siteone btn-wo-decline'
                  onClick={this.onToggleReopenPopup}
                >
                  Request to Re-open
                </button>
              </li>
            </ul>
          )}

        {/* Status: Declined */}
        {this.props.workOrderProfile.workOrder.woInformation.status === 3 && (
          <ul className='wo-detail-bottom-btn'>
            <li className='wo-edit-li'>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.onClickEditButton}
              >
                Edit
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                onClick={this.handleSubmitForReview}
              >
                Submit for review
              </button>
            </li>
          </ul>
        )}

        {/* Status: Pending */}
        {this.props.workOrderProfile.workOrder.woInformation.status === 2 && (
          <ul className='wo-detail-bottom-btn'>
            <li className='wo-edit-li'>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.onClickEditButton}
              >
                Edit
              </button>
            </li>
            <li>
              {this.state.popup.isShowOpenPendingPopup && (
                <OpenPendingPopup
                  woInformation={
                    this.props.workOrderProfile.workOrder.woInformation
                  }
                  subcontractorList={this.props.SubcontractorList}
                  userList={this.props.UserList}
                  workOrderTypeList={this.props.WorkOrderTypeList}
                  rfsInformation={this.props.rfsInformation}
                  onSaveOpenPendingPopup={this.onSaveOpenPendingPopup}
                  onCancelOpenPendingPopup={this.onToggleOpenPendingPopup}
                  onFetchSubcontractor={() =>
                    this.fetchSubcontractor(
                      this.props.workOrderProfile.workOrder.woInformation.trade
                        .id
                    )
                  }
                  onFetchUser={this.fetchUser}
                  onFetchWOT={this.onFetchWorkOrderType}
                />
              )}
              <button
                className='btn btn-primary btn-siteone'
                onClick={() => {
                  if (this.props.isPunchItem) {
                    this.onSendPunchItem();
                  } else {
                    this.onToggleOpenPendingPopup();
                  }
                }}
              >
                Send
              </button>
            </li>
            {/*
            {!this.props.isPunchItem && (
              <li>
                {this.state.popup.isShowClosePendingPopup && (
                  <ClosePendingPopup
                    rfsInformation={this.props.rfsInformation}
                    woInformation={
                      this.props.workOrderProfile.workOrder.woInformation
                    }
                    onSaveCloseReopenPopup={data =>
                      this.onReviewReopenWorkOrder(data)
                    }
                    onCancelClosePendingPopup={this.onToggleClosePendingPopup}
                    onFetchWorkOrderType={this.onFetchWorkOrderType}
                    workOrderTypeList={this.props.WorkOrderTypeList}
                    onFetchSubcontractor={this.fetchSubcontractor}
                    onFetchUser={this.fetchUser}
                    subcontractorList={this.props.SubcontractorList}
                    userList={this.props.UserList}
                  />
                )}
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-close'
                  onClick={this.onToggleClosePendingPopup}
                >
                  Close
                </button>
              </li>
            )}
                  */}
          </ul>
        )}

        {/* Status: ReOpen */}
        {this.props.workOrderProfile.workOrder.woInformation.status === 6 &&
          !this.state.isEditReOpen && (
            <ul className='wo-detail-bottom-btn'>
              <li className='wo-edit-li'>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-edit'
                  onClick={this.onClickEditButton}
                >
                  Edit
                </button>
              </li>
              <li>
                <button
                  className='btn btn-primary btn-siteone'
                  onClick={() =>
                    this.onReviewReopenWorkOrder({ status: 'Open' })
                  }
                >
                  Send
                </button>
              </li>
              <li>
                {this.state.popup.isShowCloseReopenPopup && (
                  <CloseReopenPopup
                    lastClosedDate={
                      this.props.workOrderProfile.workOrder.woInformation
                        .lastClosedDate
                    }
                    onSaveCloseReopenPopup={data =>
                      this.onReviewReopenWorkOrder(data)
                    }
                    onCancelCloseReopenPopup={this.onToggleCloseReopenPopup}
                  />
                )}
            {(this.isAdmin() === true || this.isWOCloseBtnEnabled()) &&
              <button
                  className='btn btn-primary btn-siteone-default btn-wo-close'
                  onClick={this.onToggleCloseReopenPopup}
                >
                  Close
              </button>
            }
              </li>
            </ul>
          )}
      </div>
    );
  }

  onSelectTab = selectedKey => {
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?active=${selectedKey}`
    });
    this.setState({ isReview: true });
  };

  renderEditWorkOrder = () => {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      return (
        <HomeownerEditWorkOrder
          WorkOrderProfile={this.props.workOrderProfile}
          onCancelClick={this.onClickEditButton}
        />
      );
    }
    return (
      <EditWorkOrder
        WorkOrderProfile={this.props.workOrderProfile}
        rfsInformation={this.props.rfsInformation}
        rfsId={this.props.rfsId}
        workOrderId={this.props.workOrderId}
        onCancelClick={this.onClickEditButton}
        isPunchItem={this.props.isPunchItem}
      />
    );
  };

  renderWorkOrderReview = () => {
    const { woInformation } = this.props.workOrderProfile.workOrder;
    const queryParams = new URLSearchParams(this.props.location.search);
    const active = queryParams.get('active')
      ? queryParams.get('active')
      : 'general-info';
    const conditionRenderBottomBtn =
      AppSettings.clientTypeValue === 'Homeowner' &&
      woInformation.status !== 0 &&
      woInformation.status !== 3 &&
      woInformation.status !== 4;
    return (
      <div
        className='work-order-info-wrapper box-form-siteone col-xs-12 col-sm-8 col-lg-8'
        style={{ minHeight: 690 }}
      >
        <Tab.Container id='work-order-tab' defaultActiveKey={active}>
          <div>
            <Col sm={12} style={{ padding: 0 }}>
              <Nav
                className='wo-tab'
                bsStyle='tabs'
                onSelect={this.onSelectTab}
              >
                <NavItem eventKey='general-info'>General information</NavItem>
                <NavItem eventKey='history'>History</NavItem>
              </Nav>
            </Col>
            <Col sm={12} style={{ padding: 0 }}>
              <Tab.Content animation>
                <Tab.Pane eventKey='general-info'>
                  <div
                    className='wo-general-info clearfix'
                    style={
                      conditionRenderBottomBtn
                        ? { paddingBottom: 0, marginLeft: -3 }
                        : { marginLeft: -3 }
                    }
                  >
                    {this.state.isReview ? (
                      <div>
                        <WorkOrderInfo
                          woInformation={
                            this.props.workOrderProfile.workOrder.woInformation
                          }
                          requestDetail={
                            this.props.RFSProfile &&
                            this.props.RFSProfile.project
                              ? this.props.RFSProfile
                              : this.props.workOrderProfile.requestDetail
                          }
                          isEditResolved={this.state.isEditResolved}
                          handleModeResolved={this.handleModeResolved}
                          handleSaveEditResolved={this.handleSaveEditResolved}
                          handleSaveEditAppointment={this.handleSaveEditAppointment}
                          isEditClosed={this.state.isEditClosed}
                          isEditAppointment={this.state.isEditAppointment}
                          handleModeClosed={this.handleModeClosed}
                          handleModeOpenSubcontractor={this.handleModeOpenSubcontractor}
                          handleSaveEditClosed={this.handleSaveEditClosed}
                          isEditReOpen={this.state.isEditReOpen}
                          handleModeReOpen={this.handleModeReOpen}
                          handleSaveEditReOpen={this.handleSaveEditReOpen}
                          onResendNotice={this.onResendNotice}
                          SubcontractorList={this.props.SubcontractorList}
                          UserList={this.props.UserList}
                          fetchSubcontractor={this.fetchSubcontractor}
                          fetchUser={this.fetchUser}
                          isFetchedSubcontractor={
                            this.state.isFetchedSubcontractor
                          }
                          isFetchedUser={this.state.isFetchedUser}
                          sso={this.props.UserProfile.sso}
                          isPunchItem={this.props.isPunchItem}
                        />
                        {conditionRenderBottomBtn
                          ? null
                          : this.renderButtonGroup()}
                      </div>
                    ) : (
                      this.renderEditWorkOrder()
                    )}
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey='history'>
                  {active === 'history' && (
                    <WorkOrderHistory
                      bindingWorkOrderHistory={this.bindingWorkOrderHistory}
                      WorkOrderHistories={this.props.WorkOrderHistories}
                    />
                  )}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Tab.Container>
      </div>
    );
  };

  render() {
    if (this.props.workOrderProfile && this.props.workOrderProfile.workOrder) {
      return this.renderWorkOrderReview();
    }
    return null;
  }
}

const mapStateToProps = state => {
  return {
    LotList: state.ProjectStore.LotList,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    TradeList: state.LotStore.TradeList,
    ItemRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
    UserList: state.ProjectStore.UserSelectList,
    WorkOrderCredentials: state.WorkOrderReducer.Credentials,
    RFSProfile: state.RFSStore.RFSProfile,
    WorkOrderTypeList: state.WorkOrderTypesStore.WOTList,
    WorkOrderHistories: state.WorkOrderReducer.WorkOrderHistories,
    LotStore: state.LotStore,
    UserProfile: state.UserStore.UserProfile,
    checkHomeownerWO: state.WorkOrderReducer.checkHomeownerWO,
    UploadSuccess: state.WorkOrderReducer.UploadSuccess,
    LastResolvedByDetails: state.WorkOrderReducer.LastResolvedByDetails
  };
};

export default connect(mapStateToProps)(WorkOrderInformation);



// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/work-order-information.js